import React from 'react';
import i18n from '@/utils/i18n';
import { ContainerStationSearch } from '../components/ContainerStationSearch';
import { ContentSection } from '../components/Layout/ContentSection';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

function ContainerStationSearchView() {
  useDocumentTitle('PageTitles:containerStationSearch');

  return (
    <ContentSection title={i18n.t('Common:search')} collapsable={false}>
      <ContainerStationSearch onClick={() => {}} />
    </ContentSection>
  );
}

export default ContainerStationSearchView;
